import { queryOptions, useQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function departmentsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: chatSettingsKeys.departments(storeId),
    queryFn: () => chatSettingsApi.departments(storeId),
  });
}

export function useDepartments(storeId: string) {
  return useQuery(departmentsQueryOptions(storeId));
}
